"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasRegistrationWaitinglistWorkflow = void 0;
const Types_1 = require("./Types");
const CanvasWorkflow_1 = require("./CanvasWorkflow");
const validation_1 = require("./validation/validation");
class CanvasRegistrationWaitinglistWorkflow extends CanvasWorkflow_1.CanvasWorkflow {
  constructor() {
    super();
    this.inputPin = [Types_1.InputPin.INPUT];
    this.outputPin = [Types_1.OutputPin.OUTPUT, Types_1.OutputPin.DECLINE_OUTPUT];
    this.type = Types_1.WorkflowType.REGISTRAION_WAITINGLIST;
    this.settings = this.getDefaultSettings();
    this.customProcess = {
      registration_engagement_sequence: null,
      after_waitinglist_actions: null,
      after_registration_actions: null
    };
    this.schema = validation_1.RegistrationWaitinglistSchema;
  }
  getDefaultSettings() {
    return {
      use_waiting_list: true,
      form_ids: [],
      number_of_participants: 0,
      page_ids: [],
      email_campaign_id: null,
      waitinglist_stage_name: '',
      waitinglist_email_campaign_id: null,
      waitinglist_promotion_email_campaign_id: null,
      waitinglist_thank_you_page_id: null,
      registration_completed_stage_name: '',
      registration_pending_stage_name: '',
      reserved_promotion_time: 0,
      reserved_registration_time: 0,
      thank_you_page_id: null,
      cancellation_workflow_id: null,
      decline_workflow_id: null,
      next_workflow_ids: {
        next_workflow: null
      }
    };
  }
  setNextWorkflow(pin, next_workflow_id) {
    if (pin === Types_1.OutputPin.DECLINE_OUTPUT) {
      this.settings.decline_workflow_id = next_workflow_id;
    }
    this.setDefaultNextWorkflow(pin, next_workflow_id);
  }
  getNextWorkflows() {
    const o = {};
    o[Types_1.OutputPin.DECLINE_OUTPUT] = this.settings.decline_workflow_id;
    o[Types_1.OutputPin.OUTPUT] = this.getDefaultNextWorkflow();
    return o;
  }
  setCustomProcess(s, p) {
    if (s === 'registration_engagement_sequence') {
      this.customProcess.registration_engagement_sequence = p;
    }
    if (s === 'after_waitinglist_actions') {
      this.customProcess.after_waitinglist_actions = p;
    }
    if (s === 'after_registration_actions') {
      this.customProcess.after_registration_actions = p;
    }
  }
  getProperties() {
    return [{
      attribute: 'registration_engagement_sequence',
      datasource: null,
      label: 'BEFORE_REGISTRATIONS',
      type: 'process',
      mandatory: false,
      value: null
    }, {
      attribute: 'number_of_participants',
      datasource: null,
      label: 'MAX_CAPACITY_OF_PARTICIPANTS',
      type: 'number',
      mandatory: true,
      value: this.settings.number_of_participants
    }, {
      attribute: 'reserved_registration_time',
      datasource: null,
      label: 'RESERVED_TIME_TO_COMPLETE_REGISTRATION_FORM',
      type: 'number',
      mandatory: true,
      value: this.settings.reserved_registration_time
    }, {
      attribute: 'registration_pending_stage_name',
      datasource: null,
      label: 'REGISTRATION_PENDING_STAGE_NAME',
      type: 'text',
      mandatory: true,
      value: this.settings.registration_pending_stage_name
    }, {
      attribute: 'form_ids',
      datasource: 'Form',
      label: 'FORMS',
      type: 'multiselect',
      mandatory: true,
      value: this.settings.form_ids
    }, {
      attribute: 'thank_you_page_id',
      datasource: 'Page',
      label: 'THANK_YOU_PAGE',
      type: 'select',
      mandatory: true,
      value: this.settings.thank_you_page_id
    }, {
      attribute: 'email_campaign_id',
      datasource: 'Email',
      label: 'THANK_YOU_EMAIL',
      type: 'select',
      mandatory: false,
      value: this.settings.email_campaign_id
    }, {
      attribute: 'page_ids',
      datasource: 'Page',
      label: 'ADDITIONAL_PAGES',
      type: 'multiselect',
      mandatory: false,
      value: this.settings.page_ids
    }, {
      attribute: 'use_waiting_list',
      datasource: null,
      label: 'USE_WAITING_LIST',
      type: 'boolean',
      mandatory: true,
      value: this.settings.use_waiting_list
    }, {
      attribute: 'reserved_promotion_time',
      datasource: null,
      label: 'MAXIMUM_TIME_TO_START_WITH_REGISTRATION',
      type: 'number',
      mandatory: true,
      value: this.settings.reserved_promotion_time
    }, {
      attribute: 'waitinglist_stage_name',
      datasource: null,
      label: 'WAITING_LIST_STAGE_NAME',
      type: 'text',
      mandatory: true,
      value: this.settings.waitinglist_stage_name
    }, {
      attribute: 'waitinglist_thank_you_page_id',
      datasource: 'Page',
      label: 'WAITING_LIST_THANK_YOU_PAGE',
      type: 'select',
      mandatory: true,
      value: this.settings.waitinglist_thank_you_page_id
    }, {
      attribute: 'waitinglist_email_campaign_id',
      datasource: 'Email',
      label: 'EMAIL_TO_INFORM_PARTICIPANT_IS_ON_WAITINGLIST',
      type: 'select',
      mandatory: false,
      value: this.settings.waitinglist_email_campaign_id
    }, {
      attribute: 'waitinglist_promotion_email_campaign_id',
      datasource: 'Email',
      label: 'EMAIL_TO_INFORM_PARTICIPANT_SPOT_IS_AVAILABLE',
      type: 'select',
      mandatory: false,
      value: this.settings.waitinglist_promotion_email_campaign_id
    }, {
      attribute: 'after_waitinglist_actions',
      datasource: null,
      label: 'AFTER_WAITING_LIST_REGISTRATION',
      type: 'process',
      mandatory: false,
      value: null
    }, {
      attribute: 'after_registration_actions',
      datasource: null,
      label: 'AFTER_REGISTRATIONS',
      type: 'process',
      mandatory: false,
      value: null
    }];
  }
}
exports.CanvasRegistrationWaitinglistWorkflow = CanvasRegistrationWaitinglistWorkflow;
